import { render, staticRenderFns } from "./CoreData.vue?vue&type=template&id=73bd2a23&scoped=true"
import script from "./CoreData.vue?vue&type=script&lang=ts"
export * from "./CoreData.vue?vue&type=script&lang=ts"
import style0 from "./CoreData.vue?vue&type=style&index=0&id=73bd2a23&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bd2a23",
  null
  
)

export default component.exports